import MainBlock from "../block/main_blocks/block_processing";
import ProcessingBlock from "../block/processing_block";
import { useEffect } from "react";

export default function Processing({settem, setIsOpenPopUp}) {
    useEffect(() => {
        document.title = 'Политика обработки персональных данных';
      }, []);
    return(
        <main>
            <MainBlock />
            <ProcessingBlock />
        </main>
    )
}